<template>
  <div class="header">
    <div class="block">
      <div class="items-wrapper">

        <div class="item description">
          <span class="h4">Определение</span>
          <p class="content">{{description}}</p>
        </div>
        <div class="item points">
          <span class="h4">Баллов</span>
          <p class="content">{{points}}/10</p>
        </div>
        <div class="item level">
          <span class="h4">Ваш уровень ясности</span>
          <p class="content">{{level}}</p>
        </div>

      </div>

      <div class="item bar">
        <BarGraph :bars="bar" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BarGraph from '@/components/BarGraph'

export default {
  name: 'ResultIsData',
  components: {
    BarGraph
  },
  props: {
    level: {
      type: String,
      default: 'Level'
    },
    points: {
      type: [String, Number],
      default: 'Points'
    },
    description: {
      type: String,
      default: 'Description'
    },
    bar: {
      type: Array,
      default: () => [{
        label: 'Включенность',
        name: 'involvement',
        value: 10,
        color: ['#FFDE7F', 'rgba(255, 185, 104, 0.1)']
      }]
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../css/var.scss';

.header {
  margin-bottom: 40px;
}

.block {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.items-wrapper {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-right: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, .1);

  & > * {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}

.item {
  padding-right: 20px;
}

.description {
  flex: 1.3;
}

.points {
  flex: 0.35
}

.level {
  flex: 0.7;
}

.bar {
  flex: 0.15;
}

.h4 {
  font-family: $mainFont;
  font-size: 16px;
  color: rgba(black, .5);
  line-height: 100%;
  margin-bottom: 20px;
}

.content {
  font-family: $mainFont;
  font-weight: 500;
  font-size: 18px;
  line-height: 180%;
  color: black;

  &::first-letter {
    text-transform: uppercase;
  }
}

/deep/
  .wrapper {
    margin: 0;
  }
/deep/
  .legend {
    margin: 0;
  }

/deep/
  .graph {
    height: auto;
    min-height: 200px;
  }
</style>